// extracted by css-extract-rspack-plugin
export default {"spinner":"circular-progress-module__spinner____wY1N","rotate":"circular-progress-module__rotate___L2d5R"};